export default __webpack_public_path__ + "static/media/tick.fe473fdd.svg";